module.exports = __webpack_public_path__ + "static/media/Q5 - City Park.5c39cf89.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Survey/images/Q5 - City Park.png
// module id = 602
// module chunks = 0